import { configureStore } from "@reduxjs/toolkit";

import authenticationReducer from "./authentication";
import pageReducer from "./page";
import systemReducer from "./system";
import errorReducer from "./error";

const store = configureStore({
  reducer: {
    authentication: authenticationReducer,
    page: pageReducer,
    system: systemReducer,
    error: errorReducer,
  },
});

export default store;
